import React from 'react';
import contactMail from './Images/contactMail.png';

function Contact() {
  return(
    <div className="container-fluid contactus-section">
        <div className="row">
            <div className="col-md-6">
              <div className="contact-content-box">
                  <h2>Contact <strong> Us</strong></h2>
                  <p>Discuss a project or any help</p>
                  <h5><i className="fa fa-hand-o-right"> +92-3121051633 </i></h5>
                  <a href="mailto:yaseenmighty86@gmail.com"><h5><i className="fa fa-hand-o-right"> yaseenmighty86@gmail.com </i></h5></a>
                  <div className="social-media">
                    <a href="https://www.linkedin.com/in/yaseen-ahmed-42b78b131/"><i className="fa fa-linkedin"></i></a>
                    <a href="mailto:yaseenmighty86@gmail.com"><i className="fa fa-google"></i></a>
                    <a href="https://www.facebook.com/profile.php?id=100004608039582"><i className="fa fa-facebook"></i></a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="intro-text">
                  <img src={contactMail} alt="skilled" className="img-fluid" />
              </div>
            </div>
        </div>  
    </div>
  );
}

export default Contact;

